module.exports = __webpack_public_path__ + "img/user-plus.20ee5109.svg";